import React, { createContext, useState, useEffect, useContext } from 'react';
import { jwtDecode } from 'jwt-decode'; // Asegúrate de que jwt-decode esté instalado

const AuthContext = createContext(null);

const usuarioDesdeToken = (token) => {
  const decoded = jwtDecode(token);
  const claims = decoded.data || decoded;
  return {
    id_usuario: claims.id_usuario || claims.id,
    id: claims.id || claims.id_usuario,
    nombre_usuario: claims.nombre_usuario || claims.nombre,
    nombre: claims.nombre || claims.nombre_usuario,
    email: claims.email || claims.correo_electronico,
    rol: claims.rol,
    tecnico_id: claims.tecnico_id || null,
    token,
  };
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const userFromStorage = localStorage.getItem('usuario');
        setUser(userFromStorage ? { ...usuarioDesdeToken(token), ...JSON.parse(userFromStorage), token } : usuarioDesdeToken(token));
      } catch (error) {
        console.error("Error decoding token:", error);
        localStorage.removeItem('token');
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  }, []);

  const login = (token, userData = null) => {
    localStorage.setItem('token', token);
    try {
      const user = { ...usuarioDesdeToken(token), ...(userData || {}), token };
      localStorage.setItem('usuario', JSON.stringify(user));
      setUser(user);
    } catch (error) {
      console.error("Error decoding token on login:", error);
      localStorage.removeItem('token');
      setUser(null);
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('usuario');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};